import React, { FC } from "react";
import { CircularProgress } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { DPErrorMessage, DPPageWrapper } from "Components/DP";
import theme from "../muiTheme";
import { useDPTheme } from "Styles/useDPTheme";
import useStyles from "./styles";

const DPThemeProvider: FC = ({ children }) => {
  const classes = useStyles();
  const { loading, error } = useDPTheme();

  if (loading) {
    return (
      <div className={classes.spinnerWrapper}>
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <DPPageWrapper title="Error">
        <DPErrorMessage />
      </DPPageWrapper>
    );
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default DPThemeProvider;
